export default __webpack_public_path__ + "static/onairwithlove-hostedby-a0812f8fb143905358a8c87a583f8c62.png";